import axiosx from "../axios/index";
import { useQuery } from "react-query";

export async function createTicket(data) {
  const url = `/ticket/createTicket`;
  const res = await axiosx
    .post(url, {
      data,
    })
    .then((ree) => ree)
    .catch((err) => err.response);
  if (res?.data?.success) {
    return res?.data;
  } else if (res?.data?.success === false) {
    return res?.data;
  } else {
    return "error";
  }
}

export async function fetchTicketsByPhone(phone) {
  const url = `/ticket/tickets/${phone}`;
  const res = await axiosx
    .get(url)
    .then((ree) => ree)
    .catch((err) => err.response);
  if (res?.data?.success) {
    return res?.data;
  } else if (res?.data?.success === false) {
    return res?.data;
  } else {
    return "error";
  }
}

export async function fetchTicketById(id) {
  const url = `/ticket/ticket/id/${id}`;
  const res = await axiosx
    .get(url)
    .then((ree) => ree)
    .catch((err) => err.response);
  if (res?.data?.success) {
    return res?.data;
  } else if (res?.data?.success === false) {
    return res?.data;
  } else {
    return "error";
  }
}

export async function updateTicketById(data, id, type) {
  console.log(data);
  const url = `/ticket/ticket/update/${type}`;
  const res = await axiosx
    .post(url, {
      data,
      id,
    })
    .then((ree) => ree)
    .catch((err) => err.response);
  if (res?.data?.success) {
    return res?.data;
  } else if (res?.data?.success === false) {
    return res?.data;
  } else {
    return "error";
  }
}

export async function updateContact(data) {
  const url = `ticket/contacts/update`;
  const res = await axiosx
    .post(url, {
      data,
    })
    .then((ree) => ree)
    .catch((err) => err.response);
  if (res?.data?.success) {
    return res?.data;
  } else if (res?.data?.success === false) {
    return res?.data;
  } else {
    return "error";
  }
}
